<template>
  <section ref="element">
    <LayoutHeaderComponent
      :year="year"
    >
      <template #prev>
        <coreButtonsArrowComponent
          :disabled="!minYear || year <= minYear"
          @click="[year--, scrollElementIntoView()]"
        />
      </template>
      <template #next>
        <coreButtonsArrowComponent
          :disabled="!maxYear || year >= maxYear"
          @click="[year++, scrollElementIntoView()]"
          dir="next"
        />
      </template>
    </LayoutHeaderComponent>

    <div
      :class="$style.loading"
      v-if="pending"
    >
      {{ $t('shared.loading') }} <CoreLoadingComponent />
    </div>

    <PagesEventsQueryListComponent
      v-if="!pending && eventsData?.data?.length"
      :eventsData="eventsData?.data"
      :year="year"
    />
    <LayoutNoResultsComponent v-else-if="!pending && !eventsData?.entries?.data?.length" :query="year" />
  </section>
</template>

<script lang="ts" setup>
// FIXME temp fix
const i18nIso = 'nl-NL' //baseI18nGetDefaultIso()
const element = ref(null)

const year = ref(setInitialYear())
watch(year, () => {
  updateYearQuery(year.value)
})

const route = useRoute()
const fullPath = computed(() => route?.fullPath)
watch(fullPath, () => {
  if(Number(route.query.year)) {
    year.value = Number(route.query.year)
  }
})

const scrollElementIntoView = () => {
  scrollIntoViewWithOffset(element?.value)
}

// 1
const dateTimeStart = computed(() => dayJs(`${year.value}-01-01`).startOf('year').add(1, 'day').toISOString() )
const dateTimeEnd = computed(() => dayJs(`${year.value}-01-01`).endOf('year').toISOString() )
const eventsQueryParams = computed(() => {
  return { dateTimeStart: dateTimeStart.value, dateTimeEnd: dateTimeEnd.value, locale: i18nIso }
})
const { data: eventsData, pending: eventsPending, refresh } = await useLazyAsyncData( 'eventsData', () =>
  fetchQueryPath( queryEventEntriesThumbnailByDateTimeRange(eventsQueryParams.value) ), { watch: [year]}
)

watch(eventsPending, () => {
  document.documentElement.toggleAttribute('data-pending', eventsPending.value)
})

// 3
const pending = computed(() => eventsPending.value)

// min year
const { data: minEvent } = await lazyFetchQueryPath( queryEventEntryExtremeDateTimeRange(i18nIso) )
const minYear = computed(() => dayJs(minEvent?.value?.data?.[0]?.attributes?.sortKeyAsc).year() )

// max year
const { data: maxEvent } = await lazyFetchQueryPath( queryEventEntryExtremeDateTimeRange(i18nIso, ['sortKeyAsc:desc', 'sortKeyDesc:desc']) )
const maxYear = computed(() => dayJs(maxEvent?.value?.data?.[0]?.attributes?.sortKeyDesc).year())
</script>

<style lang="scss" module>
.loading {
  composes: container font-size-large from global;
  text-align: center;
  margin-top: var(--unit--vertical);
  margin-bottom: var(--unit--vertical);
}
</style>
